import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const dashPath = (role) => ({ super_admin: "/admin", admin: "/admin", sub_admin: "/admin", educator: "/educator", content_seller: "/seller", institute: "/institute", learner: "/learner" }[role] || "/learner");

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        login(data.token, data.user);
        toast.success(`Welcome, ${data.user.name}!`);
        navigate(dashPath(data.user.role));
      } catch {
        toast.error("Google login failed");
        navigate("/login");
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="h-10 w-10 border-4 border-amber border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-muted-foreground">Signing you in...</p>
      </div>
    </div>
  );
}
